import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig, ENVIRONMENT_CONFIG } from '@ipreo/northstar';
import { MuniEnvironmentParams } from '@ipreo/muni-shared';

const APP_NAME = 'Gameday';
export const DEAL_PUSH_TIMEOUT = 10000;

export interface BillingModel {
  app: string;
}

@Injectable()
export class BillingService {
  private apiHost: string;

  constructor(
    public httpClient: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.apiHost = (config.params as MuniEnvironmentParams).apiHost;
  }

  public report(dealId: string): any {
    const requestData: BillingModel = { app: APP_NAME };

    return this.httpClient
      .post(`${this.apiHost}/api/v2/deals/${dealId}/usage`, requestData)
      .subscribe();
  }
}
